import { NgModule } from "@angular/core";
import { CookieModule } from "ngx-cookie";
import { NgxsModule } from "@ngxs/store";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxsResetPluginModule } from "ngxs-reset-plugin";
import { NgxsReduxDevtoolsPluginModule } from "@ngxs/devtools-plugin";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

// Config
import { environment } from "@env/environment";

// Modules
import { CommonModule } from "@/common/common.module";

// Stores
import { SystemStore } from "@/common/stores/system.store";

import { MulticideStore } from "./modules/admin/multicide/multicide.store";

// App Components
import { AppComponent } from "@/app.component";
import { APP_ROUTES } from "@/app.routes";

// PrimeNG Services
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from "primeng/dynamicdialog";

// Interceptor
import { HttpCacheInterceptor } from "@/common/interceptors/http-cache.interceptor";
import {NgOptimizedImage} from "@angular/common";


@NgModule({
  declarations: [
    AppComponent,
  ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        CookieModule.forRoot(),
        RouterModule.forRoot(APP_ROUTES),
        NgxsModule.forRoot(
            [
                SystemStore,
                MulticideStore
            ],
            {
                developmentMode: !environment.production,
            }
        ),
        NgxsResetPluginModule.forRoot(),
        NgxsReduxDevtoolsPluginModule.forRoot({
            disabled: environment.production,
        }),
        NgOptimizedImage,
    ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpCacheInterceptor,
      multi: true,
    },
    DialogService,
    MessageService,
    ConfirmationService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
